import Polls from './Polls';
import PollsContainer from './Polls.container';

export default PollsContainer(Polls);
